import { createAction, props } from '@ngrx/store';
import { OracleStorageActionModel } from '@models/common/oracle-storage-action.model';
import { RoleModel } from '@models/configuration/role.model';

export const createRole = createAction(
    '[Role] Create Role',
    props<{ action: OracleStorageActionModel<RoleModel> }>()
);

export const createRoleSuccess = createAction(
    '[Role] Create Role Success',
    props<{ Role: RoleModel }>()
);

export const searchRoles = createAction(
    '[Roles] Search Roles',
    props<{ action: OracleStorageActionModel<RoleModel> }>()
);

export const searchRolesSuccess = createAction(
    '[Roles] Search Roles Success',
    props<{ Roles: RoleModel[] }>()
);

export const updateRole = createAction(
    '[Role] Update Role',
    props<{ action: OracleStorageActionModel<RoleModel> }>()
);

export const updateRoleSuccess = createAction(
    '[Role] Update Role Success',
    props<{ Role: RoleModel }>()
);

export const selectRole = createAction(
    '[Role] Select Role',
    props<{ Role: RoleModel }>()
);

export const deleteRole = createAction(
    '[Role] Delete Role',
    props<{ action: OracleStorageActionModel<RoleModel> }>()
);

export const deleteRoleSuccess = createAction(
    '[Role] Delete Role Success',
    props<{ Role: RoleModel }>()
);

export const resetLoading = createAction(
    '[Loading] Reset Loading Success'
);